import * as React from "react"

function SvgSuccess(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.919 8.711L1.177 6.046 0 7.191 3.919 11 12 3.144 10.823 2 3.919 8.711z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgSuccess
